/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISharepointCreation
 */
export interface APISharepointCreation {
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreation
     */
    readonly self: string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepointCreation
     */
    isBomShare?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepointCreation
     */
    readonly isGuestRequestShare: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharepointCreation
     */
    readonly isRequestShare: boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreation
     */
    feedbackForm?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly sharedWith: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly sharedArticles: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly sharedBOMs: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly sharedGuestRequest: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly sharedRequest: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharepointCreation
     */
    readonly feedbackSubmissions: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof APISharepointCreation
     */
    readonly unreadFeedbackSubmissionCount: number;
    /**
     * 
     * @type {number}
     * @memberof APISharepointCreation
     */
    shareDuration: number;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreation
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreation
     */
    request?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharepointCreation
     */
    readonly lastModifiedAt: Date;
}

/**
 * Check if a given object implements the APISharepointCreation interface.
 */
export function instanceOfAPISharepointCreation(value: object): value is APISharepointCreation {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('isGuestRequestShare' in value) || value['isGuestRequestShare'] === undefined) return false;
    if (!('isRequestShare' in value) || value['isRequestShare'] === undefined) return false;
    if (!('sharedWith' in value) || value['sharedWith'] === undefined) return false;
    if (!('sharedArticles' in value) || value['sharedArticles'] === undefined) return false;
    if (!('sharedBOMs' in value) || value['sharedBOMs'] === undefined) return false;
    if (!('sharedGuestRequest' in value) || value['sharedGuestRequest'] === undefined) return false;
    if (!('sharedRequest' in value) || value['sharedRequest'] === undefined) return false;
    if (!('feedbackSubmissions' in value) || value['feedbackSubmissions'] === undefined) return false;
    if (!('unreadFeedbackSubmissionCount' in value) || value['unreadFeedbackSubmissionCount'] === undefined) return false;
    if (!('shareDuration' in value) || value['shareDuration'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    return true;
}

export function APISharepointCreationFromJSON(json: any): APISharepointCreation {
    return APISharepointCreationFromJSONTyped(json, false);
}

export function APISharepointCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISharepointCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'isBomShare': json['is_bom_share'] == null ? undefined : json['is_bom_share'],
        'isGuestRequestShare': json['is_guest_request_share'],
        'isRequestShare': json['is_request_share'],
        'feedbackForm': json['feedback_form'] == null ? undefined : json['feedback_form'],
        'sharedWith': json['shared_with'],
        'sharedArticles': json['shared_articles'],
        'sharedBOMs': json['shared_BOMs'],
        'sharedGuestRequest': json['shared_guest_request'],
        'sharedRequest': json['shared_request'],
        'feedbackSubmissions': json['feedback_submissions'],
        'unreadFeedbackSubmissionCount': json['unread_feedback_submission_count'],
        'shareDuration': json['share_duration'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'request': json['request'] == null ? undefined : json['request'],
        'lastModifiedAt': (new Date(json['last_modified_at'])),
    };
}

export function APISharepointCreationToJSON(value?: Omit<APISharepointCreation, 'self'|'is_guest_request_share'|'is_request_share'|'shared_with'|'shared_articles'|'shared_BOMs'|'shared_guest_request'|'shared_request'|'feedback_submissions'|'unread_feedback_submission_count'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_bom_share': value['isBomShare'],
        'feedback_form': value['feedbackForm'],
        'share_duration': value['shareDuration'],
        'guest_request': value['guestRequest'],
        'request': value['request'],
    };
}

